import CryptoJS from 'crypto-js'

var CryptographyMd5 = {

    /** 
     * @description 加密
     * @param {String} plaintext 要加密的字符串
     * @return {Array} 加密后的16进制字符串
     */
    encryptToHex: function (plaintext) {
        return CryptoJS.MD5(plaintext).toString();
    }
}

export default CryptographyMd5;